<template>
  <page-renderer />
</template>
